/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Spinner } from '../../atoms/Spinner/Spinner';
import { theme } from '../../theme/theme';

export interface LoadingViewProps {
  /** 스피너 아래 안내 문구. 예: '대시보드 로딩 중…'. */
  message?: string;
  /** 영역 최소 높이(px). 콘텐츠 영역 전체를 채워 정중앙 정렬. 기본 60vh 상당. */
  minHeight?: number;
}

const wrapStyle = (minHeight?: number) => css`
  height: 100%;
  min-height: ${minHeight ? `${minHeight}px` : '60vh'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.space.md}px;
`;

const messageStyle = css`
  font-size: ${theme.fontSize.md}px;
  color: ${theme.color.textMuted};
`;

/** 스피너 + 문구를 콘텐츠 영역 정중앙에 표시하는 공용 로딩 화면. */
export function LoadingView({ message = '로딩 중…', minHeight }: LoadingViewProps) {
  return (
    <div css={wrapStyle(minHeight)}>
      <Spinner size={40} label={message} />
      <span css={messageStyle}>{message}</span>
    </div>
  );
}
